import { valueTypes } from 'src/models/AlertsValueTypes';

export default class AlertCreationForm {
  constructor(
    alertType = null,
    alertDirection = null,
    valueType = valueTypes[0],
    frequency = null,
    withEmail = false,
    withSMS = false,
    withPush = false,
    withWebhook = false,
    targetDelta = '10',
    currencyCode = null,
    webhook = '',
    deviceToken = '',
    ) {
    this.alertType = alertType;
    this.alertDirection = alertDirection;
    this.valueType = valueType;
    this.frequency = frequency;
    this.withEmail = withEmail;
    this.withSMS = withSMS;
    this.withPush = withPush;
    this.withWebhook = withWebhook;
    this.targetDelta = targetDelta;
    this.currencyCode = currencyCode;
    this.webhook = webhook;
    this.deviceToken = deviceToken;
  }
}



// WEBPACK FOOTER //
// ./src/models/AlertCreationForm.js